import { colors, Skeleton, styled, TableCell, TableRow } from "@mui/material";
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';
import { useEffect, useRef, useState } from "react";

const TableCellText = ({ content, isLoading = false, bgColor = colors.grey[100], colSpan = 1, rowSpan = 1, sx }) => {


  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
      border: '2px solid #fff',
      backgroundColor: bgColor,
    },
  }));

  return isLoading ? <StyledTableCell sx={sx} colSpan={colSpan} rowSpan={rowSpan}><Skeleton variant="rounded" width={100} height={20} /></StyledTableCell>
    : <StyledTableCell sx={sx} colSpan={colSpan} rowSpan={rowSpan}>{content}</StyledTableCell>;
};

export default TableCellText;